import {
  Content_Microservice_URL,
  Identity_Microservice_URL,
  Media_Microservice_URL,
  Engagement_Microservice_URL,
  Payment_Microservice_URL,
  Affiliate_Microservice_URL,
  AppWatch_Microservice_URL,
  Media_UPLOAD_Microservice_URL,
} from '@wajeez-web/core/utils';
import axios, { AxiosInstance } from 'axios';

const clientSharedValues = {
  params: {},
  withCredentials: true
};
export const contentClient = axios.create({
  ...clientSharedValues,
  baseURL: Content_Microservice_URL,

  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const publicContentClient = axios.create({
  ...clientSharedValues,
  baseURL: Content_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const identityClient = axios.create({
  ...clientSharedValues,
  baseURL: Identity_Microservice_URL,

  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const publicIdentityClient = axios.create({
  ...clientSharedValues,
  baseURL: Identity_Microservice_URL,
  headers: {
    'content-language': 'ar',
    'accept-language': 'ar',
    'x-app-language-id': '1',
  },
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const publicIdentityAffiliateClient = axios.create({
  ...clientSharedValues,
  baseURL: Affiliate_Microservice_URL,
  headers: {
    'content-language': 'ar',
    'accept-language': 'ar',
    'x-app-language-id': '1',
  },
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const mediaClient = axios.create({
  ...clientSharedValues,
  baseURL: Media_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const publicMediaClient = axios.create({
  ...clientSharedValues,
  baseURL: Media_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const mediaUploadClient = axios.create({
  ...clientSharedValues,
  baseURL: Media_UPLOAD_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const publicMediaUploadClient = axios.create({
  ...clientSharedValues,
  baseURL: Media_UPLOAD_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const engagementClient = axios.create({
  ...clientSharedValues,
  baseURL: Engagement_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const publicEngagementClient = axios.create({
  ...clientSharedValues,
  baseURL: Engagement_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const paymentClient = axios.create({
  ...clientSharedValues,
  baseURL: Payment_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const affiliateClient = axios.create({
  ...clientSharedValues,
  baseURL: Affiliate_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const paymentWithoutPlatformClient = axios.create({
  ...clientSharedValues,
  baseURL: Payment_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});
export const publicPaymentClient = axios.create({
  ...clientSharedValues,
  baseURL: Payment_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const publicPaymentWithoutPlatformClient = axios.create({
  ...clientSharedValues,
  baseURL: Payment_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});
export const appWatchClient = axios.create({
  ...clientSharedValues,
  baseURL: AppWatch_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const publicAppWatchClient = axios.create({
  ...clientSharedValues,
  baseURL: AppWatch_Microservice_URL,
  transformResponse: [
    function transformResponse(data) {
      return data;
    },
  ],
});

export const ApiClient = axios.create({ ...clientSharedValues });
